import {log} from '../api/logger';
import getPricingInfoFromState from '../middleware/utils/getPricingInfoFromState';
import {getQueryParams} from '../utils/queryStringHelper';

function requestToBookModalSubmit(store) {
    const state = store.getState();
    const pricingInfo = getPricingInfoFromState(state);
    let bookingUrl = pricingInfo.checkoutUrl || null;

    // verify that bookingUrl is valid
    // listing.booknow.click is already triggered somewhere else
    // forward to checkout URL
    if (bookingUrl) {
        const queryParams = getQueryParams(window.location.search);

        if (queryParams.cid) {
            bookingUrl += `&cid=${queryParams.cid}`;
        }

        window.location.href = bookingUrl;
        return true;
    }

    // If no bookingUrl, log an error
    log({
        message: 'Error: missing checkoutUrl from pricingInfo object'
    });

    // otherwise, return false
    return false;
}

export default requestToBookModalSubmit;
export {requestToBookModalSubmit};
